import css from 'styled-jsx/css'
import { colors, measurements } from 'theme'
import fonts, { fontSizes } from 'theme/fonts'

const minWidthFieldScroll = '200px'

export default css`
  .wrapper-table-container {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .wrapper-table-container.scroll {
    overflow-x: scroll;
    max-width: 60rem;
    margin-left: auto;
    margin-right: auto;
  }

  .table-body {
    position: relative;
    width: 100%;
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${colors.alpha(colors.white, 0.4)};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media screen and (max-width: 1200px) {
    .wrapper-table-container.scroll {
      max-width: 50rem;
    }
  }

  @media screen and (max-width: 992px) {
    .wrapper-table-container {
      background-color: initial;
      border: none;
    }
    .wrapper-table-container.scroll {
      overflow-x: initial;
    }
    .wrapper-table-container,
    .wrapper-table-container.scroll {
      max-width: 30rem;
    }
  }
`

export const tableHeader = css`
  .table-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${colors.frame};
    height: 60px;
    background-color: ${colors.lightGray};
    border-bottom: 1px solid ${colors.border};
    width: auto;
    min-width: 100%;
  }

  .scroll.table-header-container {
    width: fit-content;
    min-width: 100%;
  }

  .scroll .table-header-field {
    min-width: ${minWidthFieldScroll};
  }

  .table-header-field {
    padding: 0 10px;
    font: ${fonts.bold};
    min-width: auto;
  }

  @media screen and (max-width: 992px) {
    .table-header-container {
      display: none;
    }
  }
`

export const tableItem = css`
  .table-item-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 50px;
    border-bottom: 1px solid ${colors.border};
    border-top: none;
    transition: 0.3s all;
    width: auto;
    min-width: 100%;
  }

  .scroll.table-item-container {
    width: fit-content;
    min-width: 100%;
  }

  .table-item-container.center {
    justify-content: center;
  }

  .table-item-container:hover {
    background-color: ${colors.lightGray};
  }

  .table-item-field {
    padding: 0 10px;
    text-align: left;
    font: ${fonts.regular};
    font-size: ${fontSizes.p};
    word-break: break-all;
    min-width: auto;
  }
  .scroll .table-item-field {
    min-width: ${minWidthFieldScroll};
  }

  .table-item-caption-field {
    display: none;
    word-break: normal;
    margin-right: 0.5rem;
  }

  @media screen and (max-width: 992px) {
    .table-item-container {
      max-width: 25rem;
      flex-direction: column;
      height: auto;
      margin: 1rem auto;
      border-radius: ${measurements.borderRadius};
      border-top: 1px solid ${colors.border};
      box-shadow: 0 2px 1rem 1px ${colors.alpha(colors.black, 0.08)};
      background-color: ${colors.white};
    }

    .table-item-container .table-item-field {
      display: flex;
      flex-wrap: wrap;
      padding: 0.5rem 1.3rem;
      width: 100% !important;
      line-height: 1.5rem;
      align-items: center;
    }

    .table-item-container:hover {
      background-color: ${colors.white};
    }

    .table-item-caption-field {
      display: initial;
    }
    .table-item-container .table-item-field.header-card-field {
      display: none;
    }
    .table-item-container .table-item-field.hidde-on-mobile {
      display: none;
    }
  }
`

export const headerCardStyle = css`
  .header-card-container {
    display: none;
  }
  @media screen and (max-width: 992px) {
    .header-card-container {
      display: flex;
      width: 100%;
      background-color: ${colors.lightGray};
      border-radius: ${measurements.borderRadius} ${measurements.borderRadius} 0
        0;
      border-bottom: 1px solid ${colors.border};
      font-size: ${fontSizes.p};
      padding: 0.5rem 0;
      min-height: 3rem;
    }
    .header-card-item {
      display: flex;
      justify-content: center;
      width: 100%;
      align-items: center;
      justify-content: space-around;
    }
  }
`

export const footerCardStyle = css`
  .footer-card-item {
    display: none;
  }
  @media screen and (max-width: 992px) {
    .footer-card-item {
      display: flex;
      width: 100%;
      background-color: ${colors.lightGray};
      border-radius: 0 0 ${measurements.borderRadius}
        ${measurements.borderRadius};
      border-top: 1px solid ${colors.border};
      font-size: ${fontSizes.p};
      padding: 0.5rem 0;
      min-height: 2.5rem;
      justify-content: center;
      align-items: center;
    }
  }
`
